import { EnvironmentService } from "../../../../services/EnvironmentService";
import { ObjectService } from "../../../../services/ObjectService";
import { stateT } from "../../types";
import { resolutionListT } from "../../../../utils/constants";
import { getAspectRatio as getAspectFromState } from "../uiSelectors";

import { getActiveEnvironmentStage } from "./enviromentSelectors";
import {
  getProductFromCache,
  getSelectObjectDataById,
} from "./objectSelectors";
import { getCamera } from "./sceneSelectors";

export interface ITemplateConfigData {
  organizationId: number;
  config: {
    stage: any;
    camera: any;
    aspectRatio?: resolutionListT;
    frameMeta?: { width: number; height: number };
    products: ITemplateProduct[];
  };
}

export interface ITemplateProduct {
  position: any;
  rotation: any;
  forward: any;
  up: any;
  scale: any;
  id: number;
  name: string;
  projectId: number;
  paramString: string;
  resourceUrl: string | null;
  glbResourceUrl: string | null;
  pathObjectIds: number[]; // Add folder hierarchy path
  options: any[];
}

export const getDataForTemplateConfig =
  (body: string) =>
  (state: stateT): ITemplateConfigData => {
    const stage = getActiveEnvironmentStage(state);

    if (!stage) {
      throw new Error("Stage not found");
    }

    const camera = getCamera(state);
    const aspectRatio = getAspectFromState({ ...state });

    const productsResult: ITemplateProduct[] = [];
    let cameraResult: any = null;

    const arrDataScene = JSON.parse(body) as any[];
    arrDataScene.forEach((item: any) => {
      if (item.id && item.id === "camera") {
        // Save UI FOV from Redux (camera.fov) instead of scene's adjusted FOV (item.fov)
        cameraResult = {
          ...camera,
          position: item.pos,
          forward: item.forward,
          up: item.up,
          fov: camera.fov,
          fovType: "ui",
          renderWidth: item.renderWidth || camera.renderWidth,
          renderHeight: item.renderHeight || camera.renderHeight,
          imageWidth: item.imageWidth || camera.imageWidth,
          imageHeight: item.imageHeight || camera.imageHeight,
          exposure: item.exposure || camera.exposure,
        };
      } else {
        const idProduct = item.id;
        const {
          pathObjectIds,
          geometryOptions,
          materialOptions,
          realId,
          projectId,
        } = getSelectObjectDataById(idProduct)(state);

        // const product = getProductByIdAndPath(
        //   realId,
        //   pathObjectIds,
        //   projectId
        // )(state);

        // Next try the cache by project
        const productFromCache = getProductFromCache(projectId, realId)(state);

        console.log("product", productFromCache);
        if (productFromCache) {
          const selectData = getSelectObjectDataById(idProduct)(state);
          const glbUrl = selectData?.glbData?.url;
          productsResult.push({
            position: item.localPosition,
            rotation: item.localRotation,
            forward: item.forward,
            up: item.up,
            scale: item.localScale,
            id: productFromCache.id,
            name: productFromCache.name,
            projectId: productFromCache.projectId,
            paramString: productFromCache.paramString,
            resourceUrl: productFromCache.resource ?? null,
            glbResourceUrl: glbUrl ?? null,
            pathObjectIds: pathObjectIds, // Save the folder hierarchy path
            options: [
              ...ObjectService.getOptionsByProductAndSelectData(
                "geometry",
                productFromCache,
                geometryOptions
              ),
              ...ObjectService.getOptionsByProductAndSelectData(
                "material",
                productFromCache,
                materialOptions
              ),
            ],
          });
        }
      }
    });

    if (!cameraResult) {
      throw new Error("Camera data not found in the scene data");
    }

    const { REACT_APP_NODE_ENV_KEY } = process.env;
    const organizationId = REACT_APP_NODE_ENV_KEY === "production" ? 16 : 16;

    return {
      organizationId,
      config: {
        stage: EnvironmentService.getFormattedEnvironmentData(stage),
        camera: cameraResult,
        aspectRatio: aspectRatio || undefined,
        // Persist exact frame dimensions for custom aspect so we can restore the same frame
        frameMeta:
          aspectRatio && aspectRatio.id < 0 && (aspectRatio as any).value
            ? {
                width: Number((aspectRatio as any).value.width) || 0,
                height: Number((aspectRatio as any).value.height) || 0,
              }
            : undefined,
        products: productsResult,
      },
    };
  };

export const getTemplatesCount =
  () =>
  ({ ...state }: stateT): number => {
    return state.ui.templatesCount;
  };

export const getFoldersCount =
  () =>
  ({ ...state }: stateT): number => {
    return state.ui.foldersCount;
  };
